import { type ReactNode } from 'react';
import type { Responsive } from '@mentimeter/ragnar-styled';
import type { LineHeightsEnum } from '@mentimeter/ragnar-dsc';
import type { TextT } from '@mentimeter/ragnar-ui/text';
import { TitleFontResizer } from './TitleFontResizer';
import { DEFAULT_FONT_SIZES } from './constants';

const STARTING_FONT_SIZE = '56px';
const TITLE_STYLES: TextT = {
  fontWeight: 'regular',
  fontFamily: 'heading',
  width: '100%',
};

interface TitleProps {
  color: string;
  interactiveTitleComponent: ReactNode;
  nonInteractiveTitleComponent: ReactNode;
  titleText: string;
  textAlign?: 'left' | 'right' | 'center';
  lineHeight: Responsive<LineHeightsEnum>;
  height: number;
  shouldAnimate: boolean;
}

export const ResizableTitle = ({
  interactiveTitleComponent,
  nonInteractiveTitleComponent,
  titleText,
  lineHeight,
  textAlign,
  color,
  height,
  shouldAnimate,
}: TitleProps) => {
  if (interactiveTitleComponent) {
    return (
      <TitleFontResizer
        titleText={titleText}
        height={height}
        startingFontSize={STARTING_FONT_SIZE}
        fontSizes={DEFAULT_FONT_SIZES}
        titleStyles={{
          ...TITLE_STYLES,
          lineHeight,
          textAlign,
          color,
        }}
        // we don't want to render interactive component as a Ghost because the TipTap editor is too heavy and slow
        ghostComponent={nonInteractiveTitleComponent}
        shouldAnimate={shouldAnimate}
      >
        {interactiveTitleComponent}
      </TitleFontResizer>
    );
  }

  return (
    <TitleFontResizer
      titleText={titleText}
      height={height}
      startingFontSize={STARTING_FONT_SIZE}
      fontSizes={DEFAULT_FONT_SIZES}
      titleStyles={{ ...TITLE_STYLES, lineHeight, textAlign, color }}
      shouldAnimate={shouldAnimate}
    >
      {nonInteractiveTitleComponent}
    </TitleFontResizer>
  );
};
